export default __webpack_public_path__ + "static/media/default-avatar.e11427be.jpg";